import {NgModule} from '@angular/core';
import {FormComponent} from './form.component';
import {FormFieldsComponent} from './form-fields/form-fields.component';
import {FormFieldComponent} from './form-fields/form-field/form-field.component';
import {InputsComponent} from './inputs/inputs.component';
import {TextInputComponent} from './inputs/input/text-input/text-input.component';
import {NumberInputComponent} from './inputs/input/number-input/number-input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SelectInputComponent} from './inputs/input/select-input/select-input.component';
import {CommonModule} from '@angular/common';
import {FormActionsComponent} from './form-actions/form-actions.component';
import {DateInputComponent} from './inputs/input/date-input/date-input.component';
import {FormGroupsComponent} from './form-groups/form-groups.component';
import {FormGroupComponent} from './form-groups/form-group/form-group.component';
import {ActionsModule} from '../actions/actions.module';
import {AutocompleteInputComponent} from './inputs/input/autocomplete-input/autocomplete-input.component';
import {TernaryFormFieldsComponent} from './form-fields/ternary-form-fields/ternary-form-fields.component';
import {AutocompleteInputOptionsComponent} from './inputs/input/autocomplete-input/autocomplete-input-options/autocomplete-input-options.component';
import {AutocompleteInputOptionComponent} from './inputs/input/autocomplete-input/autocomplete-input-options/autocomplete-input-option/autocomplete-input-option.component';
import {SelectInputOptionsComponent} from './inputs/input/select-input/select-input-options/select-input-options.component';
import {SelectInputOptionComponent} from './inputs/input/select-input/select-input-options/select-input-option/select-input-option.component';
import {PipesModule} from '../pipes/pipes.module';
import {InputValidationsComponent} from './inputs/input/input-validations/input-validations.component';
import {InputValidationComponent} from './inputs/input/input-validations/input-validation/input-validation.component';
import {ValidatorsModule} from '../validators/validators.module';
import {IconsModule} from '../icons/icons.module';
import {InputFacetComponent} from './inputs/input/input-facet/input-facet.component';
import {AutocompleteInputDropdownComponent} from './inputs/input/autocomplete-input/autocomplete-input-dropdown/autocomplete-input-dropdown.component';
import {AutocompleteInputDropdownOptionsComponent} from './inputs/input/autocomplete-input/autocomplete-input-dropdown/autocomplete-input-dropdown-options/autocomplete-input-dropdown-options.component';
import {AutocompleteInputDropdownOptionComponent} from './inputs/input/autocomplete-input/autocomplete-input-dropdown/autocomplete-input-dropdown-options/autocomplete-input-dropdown-option/autocomplete-input-dropdown-option.component';
import {EmailInputComponent} from './inputs/input/email-input/email-input.component';
import {PasswordInputComponent} from './inputs/input/password-input/password-input.component';
import {FileInputComponent} from './inputs/input/file-input/file-input.component';
import {DurationInputComponent} from './inputs/input/duration-input/duration-input.component';

@NgModule({
    declarations: [
        AutocompleteInputComponent,
        AutocompleteInputOptionComponent,
        AutocompleteInputOptionsComponent,
        AutocompleteInputDropdownComponent,
        AutocompleteInputDropdownOptionsComponent,
        AutocompleteInputDropdownOptionComponent,
        DateInputComponent,
        DurationInputComponent,
        EmailInputComponent,
        FileInputComponent,
        FormComponent,
        FormActionsComponent,
        FormFieldComponent,
        FormFieldsComponent,
        FormGroupsComponent,
        FormGroupComponent,
        InputsComponent,
        InputValidationComponent,
        InputValidationsComponent,
        NumberInputComponent,
        PasswordInputComponent,
        SelectInputComponent,
        SelectInputOptionComponent,
        SelectInputOptionsComponent,
        TernaryFormFieldsComponent,
        TextInputComponent,
        InputFacetComponent,
    ],
    entryComponents: [
        AutocompleteInputComponent,
        DateInputComponent,
        FormComponent,
        FormActionsComponent,
        FormFieldComponent,
        FormFieldsComponent,
        FormGroupsComponent,
        FormGroupComponent,
        InputsComponent,
        NumberInputComponent,
        SelectInputComponent,
        TextInputComponent
    ],
    exports: [
        AutocompleteInputComponent,
        AutocompleteInputOptionComponent,
        AutocompleteInputOptionsComponent,
        DateInputComponent,
        DurationInputComponent,
        FormComponent,
        FormActionsComponent,
        FormFieldComponent,
        FormFieldsComponent,
        FormGroupComponent,
        FormGroupsComponent,
        FormsModule,
        FileInputComponent,
        InputsComponent,
        NumberInputComponent,
        ReactiveFormsModule,
        SelectInputComponent,
        SelectInputOptionComponent,
        SelectInputOptionsComponent,
        TernaryFormFieldsComponent,
        TextInputComponent,
        EmailInputComponent,
        PasswordInputComponent
    ],
    imports: [
        ActionsModule,
        CommonModule,
        FormsModule,
        IconsModule,
        PipesModule,
        ReactiveFormsModule,
        ValidatorsModule
    ]
})
export class FormModule {
}
